import { useQuery } from '@tanstack/react-query'
import { fetchApiWithToken } from '~/api/utils'
import type { ApplicationJobboard } from '../types'

export const useJobboards = () =>
  useQuery({
    queryKey: ['jobboards'],
    queryFn: () =>
      fetchApiWithToken<ApplicationJobboard[]>({
        method: 'get',
        url: '/v1/jobboards'
      }),
    staleTime: 3600_000,
    refetchOnWindowFocus: false
  })
